<br>
<div class="btn btn-lg btn-block btn-outline-danger text-lg" (click)="delete()" *appViperHasUserRole="'Account Owner'">
    <i class="fas fa-ban text-lg"></i> Delete {{ switchboard_object?.object_type|alias }}
</div>